import { ChangePasswordErrorTypes } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { updatePassword } from 'shared/services/backend-api';
import { AuthFlowError } from 'shared/types/auth-flow-error';

export const useUpdatePasswordMutation = () =>
  useMutation<
    void,
    AuthFlowError<ChangePasswordErrorTypes>,
    {
      oldPassword: string;
      newPassword: string;
    }
  >({
    mutationFn: async ({ oldPassword, newPassword }) =>
      updatePassword(oldPassword, newPassword),
  });
